export enum MenuDistributionType {
  Employee,
  Register,
  Bar,
  Other
}
